import { IAbstractComponentUnion, IComponentsById, IComponentType, IComponentUnion, IRoot, ISceneComp } from "./types/components";
import { IContentDoc } from "./types/contentDoc";

/**
 * The scene list and each scene's tracking type — what decides whether JUTE's camera wrappers stay
 * mounted, and therefore the one thing a live content update must NOT change.
 *
 * Shared rather than owned by Designer's preview because both ends of the live-update contract need the
 * same answer: Designer decides whether to send an update, and JUTE decides whether to accept one.
 */
export const sceneSignatureFor = (componentsById: IComponentsById | undefined | null, rootComponentId: string | undefined | null): string => {
	if (!componentsById || !rootComponentId) return '';
	const root = componentsById[rootComponentId] as IRoot | undefined;
	return (root?.children ?? [])
		.map((id) => `${id}:${(componentsById[id] as ISceneComp | undefined)?.trackingType ?? '?'}`)
		.join(',');
};

export const sceneSignature = (doc: IContentDoc | undefined | null): string =>
	sceneSignatureFor(doc?.componentsById, doc?.rootComponentId);

export const isAbstractComponentType = (type?: IComponentType): boolean => {
	return (
		!!type && (
			type === IComponentType.Root ||
			type === IComponentType.Scene ||
			type === IComponentType.ScreenContent ||
			type === IComponentType.ScreenAnchorGroup ||
			type === IComponentType.FaceLandmarkGroup
		)
	);
 }

 export const isAbstractComponent = (component: IComponentUnion): component is IAbstractComponentUnion => {
		return isAbstractComponentType(component.type);
 };